import { useNavigate } from 'react-router-dom';
import style from './UploadModal.module.css';
import { useState } from 'react';
import SuccessfullIcon from '../../../assets/svgs/Successfull';
import ArrowLeftIcon from '../../../assets/svgs/ArrowLeft';
import Upload from './Upload';
import { useFilesContext } from '../../../contexts/FilesContext';
import Cookies from 'js-cookie';
import { useCV } from '../../../contexts/CVContext';

const UploadModal = ({ isModal = false, onClose }) => {
  const { addFile, files, removeFile } = useFilesContext();
  const [successfull, setSuccessfull] = useState(false);
  const { setIsCVUploaded } = useCV();
  const url = process.env.REACT_APP_API_URL || '';

  const [loading, setLoading] = useState(false);
  const [fileError, setFileError] = useState('');

  const navigate = useNavigate();

  const handleClose = () => {
    if (isModal && onClose) {
      onClose();
    } else {
      navigate('/dashboard/home');
    }
  };

  const backToDashboard = () => {
    setTimeout(() => {
      setIsCVUploaded(true);
      handleClose();
    }, 3000);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!Cookies.get('session_hint')) {
      alert('You must be logged in to upload files.');
      return;
    }

    if (files.length === 0) {
      setFileError('Please upload your CV to continue.');
      return;
    }

    const uploadedFile = files[0].file;

    // Validate file type
    const allowedExtensions = ['.pdf', '.doc', '.docx'];
    const fileName = uploadedFile.name?.toLowerCase() || '';
    if (!allowedExtensions.some(ext => fileName.endsWith(ext))) {
      setFileError('Unsupported file type. Please upload a PDF or Word file.');
      return;
    }

    setLoading(true);
    setFileError('');

    const formDataToSend = new FormData();
    formDataToSend.append('files', uploadedFile);

    try {
      const response = await fetch(`${url}/user/upload-cv`, {
        method: 'POST',
        credentials: 'include',
        body: formDataToSend,
        headers: { Accept: 'application/json' },
      });

      if (!response.ok) throw new Error('File upload failed');

      setSuccessfull(true);
      backToDashboard();
    } catch (error) {
      console.error('Upload error:', error);
      setFileError('Upload failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const content = (
    <div className={style.newEventContainer}>
      <button className={style.back} onClick={handleClose}>
        <ArrowLeftIcon /> {isModal ? 'Close' : 'Back to Dashboard'}
      </button>

      {successfull ? (
        <div className={style.newEventContainerSuccessfull}>
          <SuccessfullIcon width={'120px'} height={'120px'} />
          <p className={style.successfullText}>
            Your resume has been uploaded successfully
          </p>
        </div>
      ) : (
        <>
          <h1 className={style.title}>Start your personalized journey</h1>
          <p className={style.subTitle}>Upload your CV to unlock personalized insights and recommendations.</p>

          <Upload
            files={files}
            addFile={addFile}
            removeFile={removeFile}
          />

          {fileError && <p className={style.errorText}>{fileError}</p>}

          <div style={{ width: '100%', maxWidth: '600px' }}>
            <button
              className={style.createButton}
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading ? 'Uploading...' : 'Complete Upload'}
            </button>
          </div>
        </>
      )}
    </div>
  );

  if (isModal) {
    return (
      <div className={style.modalOverlay} onClick={handleClose}>
        <div className={style.modalContainer} onClick={(e) => e.stopPropagation()}>
          {content}
        </div>
      </div>
    );
  }

  return content;
};

export default UploadModal;
